import React from 'react';
import { faDice } from '@fortawesome/free-solid-svg-icons';
import { createListSection } from '../ListSection';
import { SectionItem } from '../SectionItem';
import { Highlight } from '../Highlight';
function PromotionElement({ value, highlights, position }) {
    const href = value.url;
    const id = value.id;
    const searchSection = 'Promotion';
    return (React.createElement(SectionItem, { className: "WhSearch-SectionItem--bigIcon", expectedTitle: 2, expectedDescription: 1, cutTitle: 2, cutDescription: 1, href: href, internalLink: !href.includes('http') && !href.includes('#'), icon: value.thumbnailUrl || faDice, id: id, searchSection: searchSection, position: position },
        React.createElement("div", { className: "WhSearch-SectionItem__title" },
            React.createElement(Highlight, { highlighted: highlights.title, content: value.title })),
        React.createElement("div", { className: "WhSearch-SectionItem__description" },
            React.createElement(Highlight, { highlighted: highlights.description, content: value.description }))));
}
export const PromotionSection = createListSection(PromotionElement, {
    title: 'sectionPromotionTitle',
});
//# sourceMappingURL=PromotionSection.js.map